export default {
  BusinessStockSearch: {
    threshold:'Threshold',
    ticketContent:'Ticket Content',
    ticket:'Ticket',
    trigger:'Trigger',
    triggerAll:'Trigger All',
    exportDetails: {
      button: 'Export CBM / Pallet Details',
      title: 'Export Details',
      detailType: 'Detail Type',
      pallet: 'Pallet',
      hint: 'Export CSV details for the selected customer, date and detail type.',
    },
    header: {
      spuCode: 'Product Code',
      spuName: 'Product Name',
      warehouseCode: 'Warehouse Code',
      warehouseId: 'Warehouse Name',
      skuCode: 'SKU',
      categoryIdList: 'Product Category',
      warehouseTypeCode: 'Warehouse Type',
      exceedZero: 'Stock Availability >0'
    },

    table: {
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      warehouseCode: 'Warehouse Code',
      warehouseName: 'Warehouse Name',
      usableNum: 'Available Inventory',
      stockNum: 'In-stock Inventory',
      lockNum: 'Locked Inventory',
      wayNum: 'In-transit Inventory',
      preemptionNum: 'Preoccupied Inventory',
      waitNum: 'Awaiting Receipt Inventory',
      reservedNum: 'Reserved Inventory',
      typeCode: 'Warehouse Type',
      categoryName: 'Product Category',
      brandName: 'Brand Name',
      usableNum2: 'Available ',
      stockNum2: 'In Stock',
      lockNum2: 'Committed',
      changeNum: 'Transaction',
      pallet: 'Pallet Type',
      exportFileName: 'Inventory List'
    }
  }
};
